var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function TextAlignLeft1IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 19.5C3 18.9477 3.44911 18.5 3.9954 18.5H12.0046C12.5543 18.5 13 18.9439 13 19.5C13 20.0523 12.5509 20.5 12.0046 20.5H3.9954C3.44565 20.5 3 20.0561 3 19.5ZM3 14.5C3 13.9477 3.44495 13.5 3.99985 13.5H20.0001C20.5524 13.5 21 13.9439 21 14.5C21 15.0523 20.5551 15.5 20.0001 15.5H3.99985C3.44765 15.5 3 15.0561 3 14.5ZM3 9.5C3 8.94772 3.44995 8.5 3.99562 8.5H16.0044C16.5542 8.5 17 8.94386 17 9.5C17 10.0523 16.5501 10.5 16.0044 10.5H3.99562C3.44576 10.5 3 10.0561 3 9.5ZM3 4.5C3 3.94772 3.44495 3.5 3.99985 3.5H20.0001C20.5524 3.5 21 3.94386 21 4.5C21 5.05228 20.5551 5.5 20.0001 5.5H3.99985C3.44765 5.5 3 5.05614 3 4.5Z", fill: "" })));
}
export var TextAlignLeft1Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: TextAlignLeft1IconInner }, props))); };
//# sourceMappingURL=TextAlignLeft1Icon.js.map